export const navigation = [
    {nome: 'Atendimento', icon: 'pi pi-fw pi-desktop', routerLink: ['call']},
];
